module.exports = __webpack_public_path__ + "img/caja2.62597012.gif";